import companyInfo from '../companyInfo';

/**
 * Default SEO configuration for the Senior Shopping Service website
 */

export const DEFAULT_SEO = {
  siteName: 'Senior Shopping Service',
  defaultTitle: 'Senior Shopping Service - Quality Clothing & Essentials for Senior Living',
  titleTemplate: '%s | Senior Shopping Service',
  defaultDescription: 'Senior Shopping Service provides quality clothing, adaptive wear, and essential products for assisted living facilities and senior residents. Free labeling, invoice management, and trust account payments available.',
  baseUrl: 'https://www.seniorshoppingservice.com',
  defaultKeywords: [
    'senior clothing',
    'assisted living',
    'senior care products',
    'adaptive clothing',
    'senior living essentials',
    'facility clothing service',
    'trust account shopping',
    'personalized labeling'
  ],
  defaultOgImage: '/social-share-image.png', // You'll need to add this image
  twitterHandle: '@srshoppingsvc15',
  telephone: companyInfo.phone.main,
  email: companyInfo.email.customerService,
  address: {
    streetAddress: companyInfo.shipping.address,
    addressLocality: companyInfo.shipping.city,
    addressRegion: companyInfo.shipping.state,
    postalCode: companyInfo.shipping.zip,
    addressCountry: 'US'
  },
  socialMedia: [
    companyInfo.social.facebook,
    companyInfo.social.twitter,
    companyInfo.social.youtube,
    companyInfo.social.pintrest,
    companyInfo.social.instagram
  ]
};

/**
 * Generate a full URL from a path
 */
export const generateUrl = (path: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${DEFAULT_SEO.baseUrl}${cleanPath}`;
};

/**
 * Format keywords array into a comma-separated string
 */
export const formatKeywords = (keywords: string[]): string => {
  return keywords.join(', ');
};

/**
 * Generate page title with template
 */
export const generateTitle = (pageTitle?: string): string => {
  if (!pageTitle) return DEFAULT_SEO.defaultTitle;
  return DEFAULT_SEO.titleTemplate.replace('%s', pageTitle);
};

/**
 * Truncate description to optimal length for meta tags
 */
export const truncateDescription = (description: string, maxLength = 160): string => {
  if (description.length <= maxLength) return description;
  return description.substring(0, maxLength - 3) + '...';
};
